<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{'Turbo.Order.AddCostsDialog.CostsTitle' | translate : 'Costs'}}">

    <div>{{ 'Turbo.Order.AddCostsDialog.CostsExplanation' | translate : 'Costs related to this termination' }}</div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Turbo.Order.AddCostsDialog.SpareParts' | translate : 'Spare parts' }}</mat-label>
            <input #txtcontactFirstName="ngModel" matInput placeholder="{{ 'Turbo.Order.AddCostsDialog.SpareParts' | translate : 'Spare parts' }}" [(ngModel)]="data.spareParts" type="number">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Turbo.Order.AddCostsDialog.Transport' | translate : 'Transport' }}</mat-label>
            <input #txtcontactEmail="ngModel" matInput placeholder="{{ 'Turbo.Order.AddCostsDialog.Transport' | translate : 'Transport' }}" [(ngModel)]="data.transport" type="number">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Turbo.Order.AddCostsDialog.Labor' | translate : 'Labor' }}</mat-label>
            <input #txtcontactPhone="ngModel" matInput placeholder="{{ 'Turbo.Order.AddCostsDialog.Labor' | translate : 'Labor' }}" [(ngModel)]="data.labor" type="number">
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="loader" *ngIf="loading">
      <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
      <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading"></mat-progress-bar>
    </div>
  </t4-container>

  <t4-container title="{{'Turbo.Order.AddCostsDialog.Revenue' | translate : 'Revenue'}}">

    <div class="container">
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Turbo.Order.AddCostsDialog.SalesPrice' | translate : 'Sales price' }}</mat-label>
            <input #txtcontactFirstName="ngModel" matInput placeholder="{{ 'Turbo.Order.AddCostsDialog.SpareParts' | translate : 'Spare parts' }}" [(ngModel)]="data.salesPrice" type="number">
          </mat-form-field>
        </div>
      </div>
    </div>

  </t4-container>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()" [disabled]="loading">
      {{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdSave' | translate : 'Save' }}
    </button>
  </div>
</mat-dialog-actions>
